import { ExperienceTags } from 'components/www/availability-search/filters/SearchFilterExperienceTags';
import { consumer } from '@tock/coretypes';
import React from 'react';
import _ from 'lodash';

export const useExperienceTagAggregations = (
  selectedTags: ExperienceTags,
  aggregations?: consumer.Aggregations
) => {
  const [tagAggregationsInternal, setTagAggregationsInternal] = React.useState<
    consumer.Aggregations | undefined
  >(aggregations);

  // we need to keep the aggs from no terms around so we don't disable the ones that aren't currently enabled
  React.useEffect(() => {
    if (_.every(selectedTags, _.isEmpty)) {
      setTagAggregationsInternal(aggregations);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aggregations, setTagAggregationsInternal]);

  return { tagAggregationsInternal, setTagAggregationsInternal };
};
